
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.6 1.1c1.822 0 3.3 1.478 3.3 3.3v2.75a.55.55 0 01-1.1 0V4.4a2.2 2.2 0 00-2.2-2.2H4.4a2.2 2.2 0 00-2.2 2.2v13.2a2.2 2.2 0 002.2 2.2h13.2a2.2 2.2 0 002.2-2.2v-2.75a.55.55 0 011.1 0v2.75c0 1.822-1.478 3.3-3.3 3.3H4.4a3.301 3.301 0 01-3.3-3.3V4.4c0-1.822 1.478-3.3 3.3-3.3h13.2zM12.04 7.312a.55.55 0 01.778 0L16.508 11l-3.689 3.688a.55.55 0 01-.778-.777l2.361-2.361H7.15a.55.55 0 110-1.1h7.252L12.041 8.09a.55.55 0 010-.777z","fill":"#3C464F"}})])
          )
        }
      }
    